usuarios.component('usuarios.usuariosModalComponent', {
    templateUrl: 'usuarios/usuariosModal/usuariosModal.html',
    controller: 'usuarios.usuariosModalController',
    controllerAs: '$modal',
    bindings: { config: '=' }
});

usuarios.controller('usuarios.usuariosModalController', ['$scope', 'coreLanguage', 'coreFb', function($scope, $text, $fb) {
    const $ctrl = this;
    $scope.$text = $text;

    const formErrosDefault = {
        nome:{},
        email:{},
        nivelAcesso:{},
        telefone:{
            ddi:{},
            numero:{}
        }
    };

    $ctrl.ddiOptions = [];

    const _getDominio=()=>{
        $fb.db.get('sys_dominio/ddi').then(doc=>{ $ctrl.ddiOptions = doc.data.values; });
        $ctrl.profileOptions = ['Aluno', 'Afiliado', 'Colaborador', 'Admin'];        
        $ctrl.levelOptions = ['pro', 'enterprise', 'full'];
    };

    const _getFaturaProgresso=()=>{
        $ctrl.fatura = {};
        $ctrl.progresso = {};

        $ctrl.loadingFatura = true;

        $fb.db.list(`cad_faturas`, [{where:['cliente.email', '==', $ctrl.config.dados.email]}], true).then(list=>{            
            $ctrl.fatura = list[0];

            return $fb.functions.invoke('aulas_progressByUser', { idUsuario: $ctrl.config.dados.docPath.split('/')[1] });
        }).then(progress=>{
            $ctrl.progressos = progress.map(item=>{ return {...item, inicio: new Date(1970, 0, 1).setSeconds(item.inicio._seconds), progresso: item.progresso+'%'} });

            progress = progress.filter(p=>p.inicio !== null);

            if(!progress.length){
                $ctrl.progresso = {
                    percent: '0%',
                    data: false
                };

                return;
            };

            let progresso = (progress.reduce((acc, obj) => acc += obj.progresso, 0)) / (progress.length);

            let data = new Date(1970, 0, 1);
            data.setSeconds(progress[0].inicio._seconds);

            $ctrl.progresso = {
                percent: progresso+'%',
                data: data
            };

        }).finally(()=>{
            $ctrl.loadingFatura = false;
        });
    };

    $ctrl.close=()=>{
        $ctrl.config.show = false;
        $ctrl.formErrors = formErrosDefault;
    };

    $ctrl.onBlur = (field) => {
        $ctrl.formErrors[field] = {
            field: !$scope.formContato[field].$valid,
            hint: !$scope.formContato[field].$valid
        };
    };

    $ctrl.validateForm=()=>{
        if($scope.formContato.$valid){
            $ctrl.config.confirm();
        }        
    };

    $scope.$watch('$modal.config.show', (newValue) => {
        if(newValue){ 
            $ctrl.formErrors = angular.copy(formErrosDefault);

            if($ctrl.config.dados.docPath){
                _getFaturaProgresso();
            }
        }
    });

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idUsuario;
        _getDominio();
    };

}]);